import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-z-error"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-bg tw-absolute tw-inset-0 tw-bg-mainbg1 tw-opacity-50" }, null, -1)
const _hoisted_3 = { class: "md sf-modal tw-absolute tw-inset-0" }
const _hoisted_4 = { class: "tw-flex tw-justify-center tw-items-center tw-h-full" }
const _hoisted_5 = { class: "sf-dialog-container" }
const _hoisted_6 = { class: "tw-h-full" }
const _hoisted_7 = { class: "tw-flex-auto" }
const _hoisted_8 = { class: "sf-modal-body tw-text-danger" }
const _hoisted_9 = { class: "tw-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorCmpMessage = _resolveComponent("ErrorCmpMessage")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "sf-dialog",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ErrorCmpMessage, {
                        error: _ctx.currentError,
                        onClose: _ctx.closeError
                      }, null, 8, ["error", "onClose"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          class: "sf-btn sf-btn-danger",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeError && _ctx.closeError(...args)))
                        }, " Close ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}